import { Action, createReducer, on } from "@ngrx/store";
import { AuthState } from "./auth.model";
import { CheckDigitalProfile, CheckDigitalProfileFound, GetPhoneByWalletIdFound, RegisterNewProfileSuccess, SetEmailAddress, SetFirebaseAuthToken, SetRisk, SetWalletId } from "./auth.actions";
import { DpSendValidateSuccess } from "../digital-payment/digital-payment.action";

// Todo: Tim: #mar25 - confirm what elements *actually* need to be a part of global state
const initialState: AuthState = {
  walletId: '',
  userProfile: {
    dialCode: '',
    iso2Code: '',
    phoneNumber: '',
    internationalPhoneNumber: '',
    email: ''
    // Todo: Tim: #mar25 - add additional items from the profile registration form
  },
  firebaseAuthToken: '',
  hasExistingProfile: null,
  isWalletRecognized: null,
  digitalProfileId: '',
  riskStatus: null,
  risk: null
}

export function AuthReducer(state: AuthState | undefined, action: Action) {
  return reducer(state, action)
}

export const reducer = createReducer(
  initialState,
  on(
    SetWalletId,
    (state, { walletId }) =>
      ({
        ...state,
        walletId: walletId
      })   
  ),
  on(
    SetFirebaseAuthToken,
    (state, { firebaseAuthToken }) =>
      ({
        ...state,
        firebaseAuthToken
      })   
  ),
  on(
    SetEmailAddress,
    (state, { email }) => 
      ({
        ...state,
        userProfile: {
          ...state.userProfile,
          email
        }
      })
  ),
  on(
    SetRisk,
    (state, { risk }) =>
      ({
        ...state,
        risk
      })
  ),
  on(
    GetPhoneByWalletIdFound,
    (state, {phoneDetails, digitalProfileId, riskStatus}) =>
      ({
        ...state,
        userProfile: {
          ...state.userProfile,
          dialCode: phoneDetails.countryDialCode,
          phoneNumber: phoneDetails.phoneNumber,
          internationalPhoneNumber: phoneDetails.internationalPhoneNumber
        },
        hasExistingProfile: true,
        isWalletRecognized: true,
        digitalProfileId,
        riskStatus
      }) 
  ),
  on(
    CheckDigitalProfile,
    (state, {countryDialCode, phoneNumber, internationalPhoneNumber}) => 
      ({
        ...state,
        userProfile: {
        ...state.userProfile,
        dialCode: countryDialCode,
        phoneNumber: phoneNumber,
        internationalPhoneNumber: internationalPhoneNumber
        }
      })
  ),
  on(
    DpSendValidateSuccess,
    (state, { sendValidateResponse }) =>
      ({
        ...state,
        riskStatus: {
          isRedirectRequired: sendValidateResponse?.isRedirectRequired ?? false,
        }
      })
  ),
  on(
    CheckDigitalProfileFound,
    (state, { digitalProfileId, isStepUpRequired, isRedirectRequired, journeyToken, journeyKey }) =>
      ({
        ...state,
        hasExistingProfile: digitalProfileId ? true : false,
        digitalProfileId: digitalProfileId ?? '', // Todo: Tim: this attribute will always be present if the profile is found, rework to fix type error and remove ??
        riskStatus: {
          isStepUpRequired,
          isRedirectRequired,
          journeyToken,
          journeyKey
        }
      })   
  ),
  on(
    RegisterNewProfileSuccess,
    (state, { res, riskStatus }) =>
      ({
        ...state,
        digitalProfileId: res.digitalProfileId,
        riskStatus
      })   
  ),
)